function normalizeUrls(urls) {
  return (Array.isArray(urls) ? urls : [])
    .filter((url) => typeof url === 'string' && url)
    .map((url) => ({ url }));
}

function hasClickDepthEntries(clickDepthsByUrl) {
  return (
    clickDepthsByUrl &&
    typeof clickDepthsByUrl === 'object' &&
    !Array.isArray(clickDepthsByUrl) &&
    Object.keys(clickDepthsByUrl).length > 0
  );
}

function hasPathLevelData(pathUrlsByLevel) {
  return (
    Array.isArray(pathUrlsByLevel) &&
    pathUrlsByLevel.some(
      (urlsAtLevel) => Array.isArray(urlsAtLevel) && urlsAtLevel.length > 0
    )
  );
}

function buildSectionsFromPathLevels(pathUrlsByLevel, resultsByUrl) {
  return pathUrlsByLevel
    .map((urlsAtLevel, level) => ({
      key: String(level),
      level,
      label: `Level ${level}`,
      urls: (Array.isArray(urlsAtLevel) ? urlsAtLevel : [])
        .map((url) => resultsByUrl[url])
        .filter(Boolean),
    }))
    .filter((section) => section.urls.length > 0);
}

function buildSectionsFromClickDepths(
  clickDepthsByUrl,
  pathUrlsByLevel,
  results,
  usePathFallback
) {
  const fallbackPathDepths = {};
  if (usePathFallback) {
    pathUrlsByLevel.forEach((urlsAtLevel, level) => {
      (Array.isArray(urlsAtLevel) ? urlsAtLevel : []).forEach((url) => {
        if (url && !Object.prototype.hasOwnProperty.call(fallbackPathDepths, url)) {
          fallbackPathDepths[url] = level;
        }
      });
    });
  }

  const sectionsByKey = {};
  results.forEach((result) => {
    let depth = null;
    if (Object.prototype.hasOwnProperty.call(clickDepthsByUrl, result.url)) {
      const mappedDepth = clickDepthsByUrl[result.url];
      if (Number.isInteger(mappedDepth) && mappedDepth >= 0) {
        depth = mappedDepth;
      }
    } else if (Object.prototype.hasOwnProperty.call(fallbackPathDepths, result.url)) {
      depth = fallbackPathDepths[result.url];
    }

    const key = depth === null ? 'unknown' : String(depth);
    if (!sectionsByKey[key]) {
      sectionsByKey[key] = {
        key,
        level: depth,
        label: depth === null ? 'Unknown depth' : `Level ${depth}`,
        urls: [],
      };
    }
    sectionsByKey[key].urls.push(result);
  });

  return Object.values(sectionsByKey).sort((a, b) => {
    if (a.level === null) return 1;
    if (b.level === null) return -1;
    return a.level - b.level;
  });
}

export function normalizeCrawlJobResults(job) {
  const clickDepthsByUrl = job.url_depths;
  const pathUrlsByLevel = job.urls_by_level;
  const results = normalizeUrls(job.urls);
  const resultsByUrl = results.reduce((byUrl, result) => {
    byUrl[result.url] = result;
    return byUrl;
  }, {});
  const hasClickDepths = hasClickDepthEntries(clickDepthsByUrl);
  const hasPathLevels = hasPathLevelData(pathUrlsByLevel);

  let levelSections = [];
  if (hasClickDepths) {
    levelSections = buildSectionsFromClickDepths(
      clickDepthsByUrl,
      pathUrlsByLevel,
      results,
      hasPathLevels
    );
  } else if (hasPathLevels) {
    levelSections = buildSectionsFromPathLevels(pathUrlsByLevel, resultsByUrl);
  }

  return { results, levelSections };
}
